import { render, staticRenderFns } from "./talepmalzemedetay.vue?vue&type=template&id=3b56e69e&"
import script from "./talepmalzemedetay.vue?vue&type=script&lang=js&"
export * from "./talepmalzemedetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports